<template>

    <div class="Page Page--layout-login">
        <!-- Page content -->
        <div class="Page__content page-content d-flex flex-column">
            <!-- Main content -->
            <div class="content-wrapper flex-fill">
                <!-- Content area -->
                <div class="content d-flex justify-content-center align-items-center">
                    <div>

                        <div class="text-center mb-4">
                            <img src="../../assets/images/logo-column.png">
                        </div>

                        <slot/>
                    </div>
                </div>
            </div>

            <div class="Page__bottom_bar d-flex justify-content-center align-items-center pt-2 pb-2">
<!--                <a target="_blank" href="https://www.dealercrm.pl/">-->
<!--                    <img class="m-3" src="../../assets/images/crm-logo-light.png" alt="">-->
<!--                </a>-->
<!--                <a target="_blank" href="https://www.dealerbms.pl/">-->
<!--                    <img class="m-3" src="../../assets/images/bms-logo-light.png" alt="">-->
<!--                </a>-->
<!--                <a target="_blank" href="https://www.dealerbit.pl/">-->
<!--                    <img class="m-3" src="../../assets/images/bit-logo-light.png" alt="">-->
<!--                </a>-->
<!--                <a target="_blank" href="https://www.agrocrm.pl/">-->
<!--                    <img class="m-3" src="../../assets/images/agrocrm-logo-light.png" alt="">-->
<!--                </a>-->
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        name: "LoginLayout",
    }
</script>

<style scoped>

</style>